var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormGroup',[_c('Checkbox',{model:{value:(_vm.values.boolean_default),callback:function ($$v) {_vm.$set(_vm.values, "boolean_default", $$v)},expression:"values.boolean_default"}},[_vm._v("\n    "+_vm._s(_vm.$t('fieldBooleanSubForm.defaultValue'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }